"use strict";
/**************************************************************************************************
 *
 *      @file ./core-object-detection-override.ts
 *
 *      Polyfills core JS objects to make array type checking succeed for
 *      Kotlin array objects & MobX observable arrays
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mobx_1 = require("mobx");
var shared_1 = require("mad-utils/lib/shared");
var kotlin_1 = __importDefault(require("kotlin"));
/****************************** SET instanceof AND isArray BEHAVIOUR ******************************/
var isArrayOrig = Array.isArray;
/**
 * Includes handling for environments with no Symbol.hasInstance
 */
var hasInstanceOrig = Array[Symbol && Symbol.hasInstance] ||
    (function (val) { return val instanceof Array || val instanceof Array.prototype.constructor; });
// prettier-ignore
/**
 * If true, value is an array
 */
function detectArray(val) {
    return isArrayOrig(val) || hasInstanceOrig(val)
        || val instanceof kotlin_1.default.kotlin.collections.ArrayList
        || mobx_1.isObservableArray(val)
        || kotlin_1.default.kotlin.collections.EmptyList === val;
}
/********************************************* EXPORT *********************************************/
/**
 * Globally polyfills core JS objects to make array type checking succeed for
 * Kotlin & MobX arrays
 *
 * `instanceof Array` & `Array.isArray` will both return true for Kotlin & MobX
 * arrays after this is run
 *
 * Example:
 *     // Install polyfill globally
 *     applyArrayDetectionOverrides();
 *
 *     // Kotlin array detection behaviour post-installation:
 *     myKotlinArray instanceof Array // => true
 *     Array.isArray(myKotlinArray)   // => true
 *
 *     // MobX array detection behaviour post-installation:
 *     mobx.observable([]) instanceof Array        // => true
 *     Array.isArray(mobx.observable([1, 2, 3]))   // => true
 */
function applyArrayDetectionOverrides() {
    shared_1.defineProperty(Array, Symbol.hasInstance, function hasInstanceArray(instance) {
        return detectArray(instance);
    });
    /**
     * Override isArray, to make it claim that Kotlin ArrayList objects are arrays
     */
    Array.isArray = function isArray(arg) {
        return detectArray(arg);
    };
}
exports.applyArrayDetectionOverrides = applyArrayDetectionOverrides;
//# sourceMappingURL=core-object-detection-override.js.map